import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("キャンセル")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("移動")

import CategoryList from "@/components/common/categories/CategoryList.vue"
  import { LearningCategory } from '@/types/learning_category'
  import {
    ref,
  } from 'vue'

  interface Props {
    modelValue: boolean;
    title: string;
    categories: LearningCategory[];
  }
  interface Emits {
    (e: 'update:modelValue', value: boolean): void;
    (e: 'submit', category: {}): void;
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { type: Boolean, required: true },
    title: { type: String, required: true },
    categories: { type: Array, required: true }
  },
  emits: ["update:modelValue", "submit"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'update:modelValue', value: boolean): void;
    (e: 'submit', category: {}): void;
  }), expose: any, slots: any, attrs: any }) {

  

  

  const selectedCategory = ref({});

  const handleSubmit = () => {
    emit('submit', selectedCategory.value);
  };

  const handleClose = () => {
    emit('update:modelValue', false);
  };

  const handleNodeClick = (category: any) => {
    selectedCategory.value = category;
  };

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: __props.title,
    modelValue: __props.modelValue,
    width: "30%",
    "destroy-on-close": "",
    onClose: handleClose
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, { onClick: handleClose }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: handleSubmit
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(CategoryList, {
        categories: __props.categories,
        onListClick: handleNodeClick,
        hideAll: true
      }, null, 8, ["categories"])
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}
}

})